/* MYREVIA — page produit « soir » : carrousels, galerie, offres, onglets, frise, accordéons */
(function () {
  if (window.__msBound) return;
  window.__msBound = true;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function bind(root) {
    root = root || document;

    // Carrousels à défilement (avis, UGC)
    root.querySelectorAll('[data-ms-slider]').forEach(function (box) {
      if (box.dataset.msBound) return;
      box.dataset.msBound = '1';
      var track = box.querySelector('[data-ms-track]');
      if (!track) return;
      var dots = box.querySelectorAll('[data-ms-dot]');
      var step = function () {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      var prev = box.querySelector('[data-ms-prev]');
      var next = box.querySelector('[data-ms-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { track.scrollTo({ left: step() * i, behavior: 'smooth' }); });
      });
      var sync = function () {
        if (!dots.length) return;
        var i = Math.round(track.scrollLeft / step());
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });

    // Galerie produit
    root.querySelectorAll('[data-ms-gal]').forEach(function (gal) {
      if (gal.dataset.msBound) return;
      gal.dataset.msBound = '1';
      var main = gal.querySelector('[data-ms-gal-main]');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-ms-thumb]'));
      if (!main || !thumbs.length) return;
      var cur = 0;
      var show = function (i) {
        cur = (i + thumbs.length) % thumbs.length;
        var t = thumbs[cur];
        main.src = t.dataset.src;
        main.removeAttribute('srcset');
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      };
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      var p = gal.querySelector('[data-ms-gal-prev]');
      var n = gal.querySelector('[data-ms-gal-next]');
      if (p) p.addEventListener('click', function () { show(cur - 1); });
      if (n) n.addEventListener('click', function () { show(cur + 1); });
    });

    // Sélecteur d'offre + prix dans le bouton
    root.querySelectorAll('[data-ms-plans]').forEach(function (wrap) {
      if (wrap.dataset.msBound) return;
      wrap.dataset.msBound = '1';
      var form = wrap.closest('form');
      var priceEl = form ? form.querySelector('[data-ms-buy-price]') : null;
      var sync = function () {
        wrap.querySelectorAll('[data-ms-plan]').forEach(function (p) {
          var input = p.querySelector('input[type=radio]');
          var on = input && input.checked;
          p.setAttribute('data-active', on ? 'true' : 'false');
          if (on && priceEl && p.dataset.price) priceEl.textContent = money(parseInt(p.dataset.price, 10));
        });
      };
      wrap.addEventListener('change', sync);
      sync();
    });

    // Onglets de la formule
    root.querySelectorAll('[data-ms-tabs]').forEach(function (box) {
      if (box.dataset.msBound) return;
      box.dataset.msBound = '1';
      var tabs = box.querySelectorAll('[data-ms-tab]');
      var panels = box.querySelectorAll('[data-ms-panel]');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, k) { x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
          panels.forEach(function (x, k) { x.setAttribute('data-open', k === i ? 'true' : 'false'); });
        });
      });
    });

    // Frise « une journée »
    root.querySelectorAll('[data-ms-day]').forEach(function (box) {
      if (box.dataset.msBound) return;
      box.dataset.msBound = '1';
      var cards = Array.prototype.slice.call(box.querySelectorAll('[data-ms-day-card]'));
      var steps = box.querySelectorAll('[data-ms-day-step]');
      var prog = box.querySelector('[data-ms-day-prog]');
      var cur = 0;
      var set = function (i) {
        cur = (i + cards.length) % cards.length;
        cards.forEach(function (c, k) { c.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
        steps.forEach(function (s, k) { s.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
        if (prog) prog.style.width = ((cur + 1) / cards.length * 100) + '%';
      };
      cards.forEach(function (c, i) { c.addEventListener('click', function () { set(i); }); });
      steps.forEach(function (s, i) { s.addEventListener('click', function () { set(i); }); });
      var p = box.querySelector('[data-ms-day-prev]');
      var n = box.querySelector('[data-ms-day-next]');
      if (p) p.addEventListener('click', function () { set(cur - 1); });
      if (n) n.addEventListener('click', function () { set(cur + 1); });
      set(0);
    });

    // Accordéons (un seul ouvert à la fois)
    root.querySelectorAll('[data-ms-acc]').forEach(function (acc) {
      if (acc.dataset.msBound) return;
      acc.dataset.msBound = '1';
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.ms-acc__b');
        if (!btn || !acc.contains(btn)) return;
        var item = btn.closest('.ms-acc__i');
        var open = item.getAttribute('data-open') === 'true';
        acc.querySelectorAll('.ms-acc__i').forEach(function (i) {
          i.setAttribute('data-open', 'false');
          var b = i.querySelector('.ms-acc__b');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
